import { Typography, Box, useTheme } from '@mui/material';
import { useTranslation } from 'next-i18next';

import RegulatorSectionStyle from './style';

import CpdCard from '@components/molecules/imageContentBox/CpdCard';

const RegulatorSection = () => {
  const { t } = useTranslation('common');
  const theme = useTheme();

  return (
    <RegulatorSectionStyle>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: '40px' }}>
        <Typography color={theme.palette.primaryCPD.main} variant="h1" align="center" className="topic">
          {t('cpd_landing.course.tsi')}
        </Typography>
        <CpdCard
          imagePathName="/assets/cpd-landing/SkillLaneCPD-Logo-gray-bg@2x.png"
          imageAlt={`${t('cpd.common.course_training_hourly_collect')} ${t('cpd.tsi.applicant_type')}`}
          topic={t('cpd.tsi.cpd_card.applicant_type')}
          subTopic={t('cpd.tsi.cpd_card.title')}
          descriptions={[
            t('cpd_landing.course.tsi.license_type.general'),
            t('cpd_landing.course.tsi.license_type.complex'),
            t('cpd_landing.course.tsi.license_type.ip'),
          ]}
          link="/cpd/tsi"
          buttonText={t('cpd_course.view_training_course')}
        />
      </Box>
      <Box>
        <Typography color="#164843" variant="h1" align="center" sx={{ mb: 4 }} className="topic">
          {t('cpd_landing.course.oic')}
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
          <CpdCard
            imagePathName="/assets/cpd-landing/TIPA-Logo-gray-bg@2x.png"
            imageAlt={`${t('cpd.common.course_training_hourly_collect')} ${t('cpd_course.applicant_type.broker')} / ${t(
              'cpd_course.applicant_type.agent',
            )} ${t('cpd_course.license_types.oic.life')}`}
            topic={t('cpd.oic.cpd_card.applicant_type')}
            subTopic={t('cpd.oic.tipa.cpd_card.title')}
            descriptions={[
              t('cpd.common.request.license'),
              `${t('cpd.common.renewal.license')}${t('cpd.common.time.1-3')}`,
              `${t('cpd.common.renewal.license')}${t('cpd.common.time.4+')}`,
            ]}
            link="https://e-learning.tip-ac.com/?utm_term=skl"
            isExternalLink
            buttonText={t('cpd_course.view_detail_training_course')}
          />

          {/* TODO: Waiting for CPD TII Business confirming */}
          {/* <CpdCard
            imagePathName="/assets/cpd-landing/TII-Logo-gray-bg@2x.png"
            imageAlt={`${t('cpd.common.course_training_hourly_collect')} ${t('cpd_course.applicant_type.broker')} / ${t(
              'cpd_course.applicant_type.agent',
            )} ${t('cpd_course.license_types.oic.non_life')}`}
            topic={t('cpd.oic.cpd_card.applicant_type')}
            subTopic={t('cpd.oic.tii.cpd_card.title')}
            descriptions={[
              t('cpd.common.request.license'),
              `${t('cpd.common.renewal.license')}${t('cpd.common.time.1-3')}`,
              `${t('cpd.common.renewal.license')}${t('cpd.common.time.4+')}`,
            ]}
            // TODO: Change to real cpd detail link
            link="https://skilllane.com/"
            buttonText={t('cpd_course.view_detail_training_course')}
          /> */}
        </Box>
      </Box>
    </RegulatorSectionStyle>
  );
};

export default RegulatorSection;
